import { Container } from '@plone/components';
import config from '@plone/volto/registry';
import cx from 'classnames';
import Component from '@plone/volto/components/theme/Component/Component';
import DefaultSummary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import { FormattedMessage } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

const LatestNewsView = (props) => {
  const { data, editable } = props;

  return (
    <div className="block latest-news ">
      <Container className="details-container">
        {data?.items && data.items.length > 0 && (
          <div className="latest-news-list">
            {data.items.map((item, index) => {
              const latest_news_item = item.item || {};
              const CustomItemBodyTemplate = config.getComponent({
                name: 'SummaryListingItemTemplate',
                dependencies: [latest_news_item['@type']],
              }).component;
              const ItemBodyTemplate = () =>
                CustomItemBodyTemplate ? (
                  <CustomItemBodyTemplate
                    item={latest_news_item}
                    isEditMode={editable}
                  />
                ) : (
                  <>
                    <div className="listing-body">
                      <DefaultSummary item={latest_news_item} HeadingTag="h3" />
                      <ConditionalLink
                        item={latest_news_item}
                        condition={!editable}
                        className="listing-readmore"
                      >
                        <FormattedMessage
                          id="listing.readmore.more"
                          defaultMessage="Mehr"
                        />
                      </ConditionalLink>
                    </div>
                    <Component
                      componentName="PreviewImage"
                      item={latest_news_item}
                      alt=""
                    />
                  </>
                );
              return (
                <div
                  className={cx(
                    'listing-item q container',
                    latest_news_item['@type']?.replace('saw.persons.', ''),
                  )}
                  key={latest_news_item['@id']}
                >
                  <ItemBodyTemplate
                    item={latest_news_item}
                    isEditMode={editable}
                  />
                </div>
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default LatestNewsView;
